<template>
    <div class='t_content_view'>
        
        <div style="margin-bottom: 20px;">关联关键词</div>
        <div style="display: flex;">
           
                <div class="t_search_select" style="padding-top:0;padding-bottom:0;margin-bottom: 0;">
                    <span style="color: #6D6D6D;">企微主体：</span>
                    <el-select style="width: 180px;"  size="small" v-model="searchform.data.corp_id" clearable placeholder="请选择">
                        
                        <el-option v-for="(item,index) in corpList.data" 
                        :key="index"
                        :label="item.corp_name" :value="item.id" />
                    </el-select>
                </div>
            
                <div class="t_search_select" style="padding-top:0;padding-bottom:0;margin-bottom: 0;">
                    <el-input
                        v-model="searchform.data.title"
                        placeholder="请输入关键词组名" :prefix-icon="Search" clearable>
                    </el-input>
                </div>
                

                <el-button color="#F1F3F9" type="primary" @click="searchbtn()" >查询</el-button>
        </div>
        

        <el-button color="#FF9A27" style="color: white;margin-top: 15px;" @click="openkeycon()" >添加关键词</el-button>

        <el-table 
        :data="tableData.data" 
        style="width: 100%;margin-top: 20px;" 
        :header-cell-style="{backgroundColor:'#F1F3F9'}">
            
            <el-table-column prop="title" label="关键词组名"  />
            <el-table-column prop="name" label="关键词组"  >
                <template #default="scope">
                    <div class="t_key_arr_box">
                        <div class="t_key_arr_item" v-for="(item , index ) in scope.row.keyword_sets" :key="index">
                            <div v-for="(item2,index2) in item.keywords" :key="index2">{{ item2.keyword }}</div>
                            
                        </div>
                        <!-- <Edit @click="openkeycon(scope.row)" class="t_edit_icon"  /> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="关键词回复内容" >
                <template #default="scope">
                    <div class="t_key_arr_box">
                        <div v-html="convertNewLinesToBr(scope.row.content)"></div>
                        <!-- <Edit @click="openbackcon(scope.row)" class="t_edit_icon"  /> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="是否启用" >
                <template #default="scope">
                    <div class="t_key_arr_box">
                        <!-- <div v-html="convertNewLinesToBr(scope.row.content)"></div> -->
                        <!-- <Edit @click="openbackcon(scope.row)" class="t_edit_icon"  /> -->
                         <div style="color: green;" v-if="scope.row.status==1">启用</div>
                         <div style="color: red;" v-else>禁用</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" >
                <template #default="scope">
                    <div @click="openkeycon(scope.row)" class="t_del_btn">编辑</div>
                    <div @click="delitem(scope.row.id)" class="t_del_btn">删除</div>
                </template>
            </el-table-column>
        </el-table>
        <!-- <div class="t_cz_box">
            <el-button>取消</el-button>
            <el-button color="#4F46E5" type="primary">确认添加</el-button>
        </div> -->

        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchform.page" @page_change="page_change" />
    
     
    </div>
 
    <!-- 关键词回复内容 -->
    <!-- <el-dialog
        v-model="isshowkeyback"
        title="关键词回复内容"
        width="500px">
        <el-input
            :rows="10"
            type="textarea"
            placeholder="输入关键词回复内容"
            v-model="backcon"
         clearable />
        <div class="t_dig_btn_box">
            <el-button @click="isshowkeyback = false">取消</el-button>
            <el-button @click="addbackcon" color="#4F46E5" type="primary">确认添加</el-button>
        </div>
    </el-dialog> -->
    <!-- 关键词组 -->
    <el-dialog
        v-model="isshowwords"
        title=""
        width="500px">
        <div class="t_key_dig_con">
            <div class="t_key_title_box"  >
                <div class="t_key_title_font" >添加关键词</div>
            </div>
            <el-input v-model="keytitle" class="t_key_input"  placeholder="请输入词组名"  clearable />
            <el-input
                :rows="5"
                type="textarea"
                placeholder="输入关键词回复内容"
                v-model="backcon"
                style="margin-top: 20px;"
             clearable />
            
         
            
            <div class="t_key_title_box" style="margin-top: 20px;"  >
                <div class="t_key_title_font" >添加关键词(需全匹配)</div>
                <div style="color: #666666;font-size: 15px;">添加上限4个</div>
            </div>
            <div v-for="(item,index) in keywordslistall.data" :key="index"  class="t_keywords_item">
                <div>{{ item }}</div>
                <div class="t_key_del" @click="falsedel(index)">删除</div>
            </div>
            <div>
                <el-input v-model="falsekey" class="t_key_input" style="width: 370px;margin-right: 8px;" placeholder="请输入关键词"  clearable />
                <el-button @click="falseadd">添加</el-button>
            </div>



            <div class="t_key_title_box" style="margin-top: 20px;"  >
                <div class="t_key_title_font" >添加关键词(任一匹配)</div>
                <div style="color: #666666;font-size: 15px;">添加上限4个</div>
            </div>
            <div v-for="(item,index) in keywordslistone.data" :key="index"  class="t_keywords_item">
                <div>{{ item }}</div>
                <div class="t_key_del" @click="falsedelone(index)">删除</div>
            </div>
            <div>
                <el-input v-model="falsekeyone" class="t_key_input" style="width: 370px;margin-right: 8px;" placeholder="请输入关键词"  clearable />
                <el-button @click="falseaddone">添加</el-button>
            </div>
            <div style="margin-top: 20px;" class="t_key_title_font" >
                是否启用：<el-switch :active-value="1"
            :inactive-value="0" v-model="status" />
            </div>
            
            <el-select   size="small" v-model="choosecorp_id" clearable placeholder="请选择主体">
                
                <el-option v-for="(item,index) in corpList.data" 
                :key="index"
                :label="item.corp_name" :value="item.id" />
            </el-select>
            <div class="t_dig_btn_box">
                <el-button @click="isshowwords = false">取消</el-button>
                <el-button @click="addkey" color="#4F46E5" type="primary">确认添加</el-button>
            </div>
        </div>
        
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload ,Plus ,Close} from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { conslist,chatcon,keylist,delkeyword,addkeyword,editkeyword,newcreatekey,newkeylist,neweditkey,newdelkey,newgetcomp2} from '@/assets/js/common.js'
//获取路由参数 
const route = useRoute()
//路由跳转
const router = useRouter()

//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    getlist()
   //获取企微主体下拉
    getcorplist()
})
//列表数据
const tableData = reactive({
    data:[ ]
})

const searchform = reactive({
    data:{
        page:1,
        page_size:20,
        title:'',
        corp_id:''
    }
})
//成员总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchform.page = val
    //人员列表
    getlist()
}
//获取列表
 const getlist = ()=>{
    newkeylist(searchform.data).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log('获取列表')
            console.log(response.data)
            tableData.data = response.data.data.data
            total.value = response.data.data.total
        }
    })
 }


const searchbtn = ()=>{
    searchform.page = 1
    //人员列表
    getlist()
}


//是否显示编辑回复内容
const isshowkeyback = ref(false)

//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}

//编辑回复内容
const openbackcon = (row)=>{
    backcon.value = row.text
    editornew.data = row
    isshowkeyback.value = true
}
//添加回复内容
const addbackcon = ()=>{
    
    editkeyword(_url2,{
        id:editornew.data.id,
        text:backcon.value
    }).then((response)=>{
            if (response.data.msg.code == 0) {
                isshowkeyback.value = false
                ElMessage({
                    message: '操作成功',
                    type: 'success',
                })
                getlist()
            }
        })
}

//是否显示关键词弹窗
const isshowwords = ref(false)


//选择企微主体
const choosecorp_id = ref('')

//关键词组名
const keytitle = ref('')

//回复内容
const backcon = ref('')

//关键词列表-完全匹配
const keywordslistall = reactive({
    data:[]
})

//关键词列表-任一匹配
const keywordslistone = reactive({
    data:[]
})

//是否启用
const status = ref(1)

//添加key
const addkey = ()=>{
    var keyword_setslist = []
    if(keywordslistall.data.length>0){
        keyword_setslist.push({
                logic_type:0,
                keywords:keywordslistall.data
            })
        // for(var x=0;x<keywordslistall.data.length;x++){
            
        // }
        
    }
    if(keywordslistone.data.length>0){
        // for(var x=0;x<keywordslistone.data.length;x++){
            
        // }
        keyword_setslist.push({
                logic_type:1,
                keywords:keywordslistone.data
            })
    
    }
    if(editornew.data.id){
        //编辑
        var obj = {
            id:editornew.data.id,
            title:keytitle.value,
            content:backcon.value,
            status:status.value,
            keyword_sets:keyword_setslist,
            corp_id:choosecorp_id.value
        }
        console.log(obj)
        neweditkey(obj).then((response)=>{
            if (response.data.msg.code == 0) {
                isshowwords.value = false
                ElMessage({
                    message: '操作成功',
                    type: 'success',
                })
                getlist()
            }
        })
    }else{
        //新增
        var obj = {
            title:keytitle.value,
            content:backcon.value,
            status:status.value,
            keyword_sets:keyword_setslist,
            corp_id:choosecorp_id.value
        }
        console.log(obj)
        newcreatekey(obj).then((response)=>{
            if (response.data.msg.code == 0) {
                isshowwords.value = false
                ElMessage({
                    message: '操作成功',
                    type: 'success',
                })
                getlist()
            }
        })
    }
    

        
}

//假删关键词
const falsedel = (i)=>{
    var arr = keywordslistall.data
    arr.splice(i, 1)
    keywordslistall.data = arr
}

//假删关键词
const falsedelone = (i)=>{
    var arr = keywordslistone.data
    arr.splice(i, 1)
    keywordslistone.data = arr
}

//添加内容
const falsekey = ref('')

//添加内容
const falsekeyone = ref('')

//假添加
const falseadd = ()=>{
    if(keywordslistall.data.length==4){
        ElMessage.error('不能超过四个')
        return
    }else{
        keywordslistall.data.push(falsekey.value)
        falsekey.value = ''
    }
    
}
//假添加
const falseaddone = ()=>{
    if(keywordslistone.data.length==4){
        ElMessage.error('不能超过四个')
        return
    }else{
        keywordslistone.data.push(falsekeyone.value)
        falsekeyone.value = ''
    }
    
}

//当前是编辑还是新增
const editornew = reactive({
    data:{}
})

//编辑关键词
 const openkeycon = (row)=>{

    if(row){
        //编辑
        keytitle.value = row.title  
        backcon.value = row.content
        keywordslistall.data = []
        falsekey.value = ''
        keywordslistone.data = []
        falsekeyone.value = ''
        editornew.data = row
        status.value = row.status
        choosecorp_id.value = row.corp_id

        for(var x = 0;x<row.keyword_sets.length;x++){
            if(row.keyword_sets[x].logic_type==1){
              for(var y=0;y<row.keyword_sets[x].keywords.length;y++){
                keywordslistone.data.push(row.keyword_sets[x].keywords[y].keyword) 
              }
            }else{
                for(var y=0;y<row.keyword_sets[x].keywords.length;y++){
                    keywordslistall.data.push(row.keyword_sets[x].keywords[y].keyword) 
                }
            }
        }
 
    }else{
        //新增
        keytitle.value = ''
        backcon.value = ''
        keywordslistall.data = []
        falsekey.value = ''
        keywordslistone.data = []
        falsekeyone.value = ''
        editornew.data = {}
        status.value = 1
        choosecorp_id.value = ''
   
    }
    isshowwords.value = true
 }

//删除
const delitem = (id)=>{
    ElMessageBox.confirm(
    '是否确认删除',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelkey({id:id}).then((response)=>{
            if (response.data.msg.code == 0) {
                ElMessage({
                    message: '操作成功',
                    type: 'success',
                })
                getlist()
            }
        })
     
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}

const convertNewLinesToBr = (text)=> {
    return text.replace(/\n/g, '<br>');
  }
</script>
<style scoped>

.t_autokeyword_box{
    padding: 30px;
    box-sizing: border-box;
    background-color: white;
   }
   .t_auto_search_box{
    display: flex;
    align-items: center;
    background-color: #F6F8FB;
    border-radius: 8px;
    border: 1px solid #e3e8f1;
    width: 280px;
    font-size: 15px;
   }
   .t_auto_input{
    width: 240px;
   }
   :deep(.t_auto_input .el-input__wrapper){
    background-color:#F6F8FB ;
    box-shadow: none;
   }
   .t_key_arr_box{
    display: flex;
    flex-wrap: wrap;
   }
   .t_key_arr_item{
    border-radius: 4px;
    background: #f7f8fa;
    padding: 2px 10px;
    margin-right: 10px;
    margin-bottom: 5px;
   }
   .t_edit_icon{
    width: 20px;
    color: #4F46E5;
    cursor: pointer;
    margin-left: 10px;
   }
   .t_del_btn{
    color: #4F46E5;
    cursor: pointer;
   }
   .t_cz_box{
    display: flex;
    justify-content: center;
    margin-top: 50px;
    padding-bottom: 50px;
    
   }
   :deep(.el-table .el-table__cell){
    padding: 15px 0;
   }
   .t_dig_btn_box{
    margin-top: 20px;
    display: flex;
    justify-content: end;
   }
   .t_keywords_item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #666666;
   }
   .t_key_del{
    cursor: pointer;
    color: #4F46E5;
   }
   .t_key_title_box{
    display:flex;
    align-items: center;
    margin-bottom: 15px;
   }
   .t_key_title_font{
    margin-right: 20px;
    color: #333333;
    font-size: 19px;
   }
   .t_key_dig_con{
    padding: 0px 10px 10px 10px;
    box-sizing: border-box;
   }
   :deep(.t_key_input .el-input__wrapper){
    background-color: #F6F8FB;
   }
      :deep(.t_key_input .el-input__wrapper){
    background-color: #F6F8FB;
   }
   :deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_select .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}

</style>